import { render } from "./ExpertStatisticsAnswerUnansweredCallsWeekYear.vue?vue&type=template&id=71e77db0"
import script from "./ExpertStatisticsAnswerUnansweredCallsWeekYear.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsAnswerUnansweredCallsWeekYear.vue?vue&type=script&lang=js"

import "./ExpertStatisticsAnswerUnansweredCallsWeekYear.vue?vue&type=style&index=0&id=71e77db0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__